export const TERMS_URL = "https://sitewrap.io/terms/";
export const PRIVACY_URL = "https://sitewrap.io/privacy-policy/";
